import React, { useState, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Icon, Input, Button, Table, Modal, Popover, Typography} from "antd";
import { Link } from "react-router-dom";
import ayudaBAcudirJDE from '../../../img/ayudaBAcudirJDE.png';
import ayudaAsignar from '../../../img/ayudaAsignar.png';
import { etiqueta_bandeja_informacion_sin_documentos, REGEX_FORMATO_SOLO_DIGITOS, etiqueta_mensaje_enviado, etiqueta_mensaje_no_enviado, etiqueta_mensaje_vacio_aspirante, etiqueta_bandeja_compulsa_en_ejecucion } from '../../../ApplicationResources';
import { obtenerIpCliente, obtenerNombreBandeja } from "../../../utils/funciones";
import { cargarAspirante, descargarAcuseCompulsa } from "../../../utils/funciones";
import { implantarAspirante } from "../../../redux/user/user-actions";
import { emitirOperacion } from "../../../redux/actions/accionesOperacion";
import { connect } from "react-redux";
import axios from "axios";
import { ModalCorreo } from "./ModalCorreo";
import { selectProceso } from "../../../redux/menu/menu-selectors";
import { createStructuredSelector } from "reselect";
import iconoDeclina from '../../../img/icons/Icono_declinacion.png';
import { selectCurrentUser } from "../../../redux/user/user-selectors";
import * as etiquetas from '../../../ApplicationResources';
import errorImgModal from '../../../img/error_icon.svg';
import { general_error_descarga_archivo,bandeja_descarga_pdf_compulsa_en_proceso,TIPO_ARCHIVO_PDF} from '../../../ApplicationResources';
import infoImgModal from '../../../img/infow_icon.png';
const { TextArea } = Input;
const { Column } = Table;
const { Text } = Typography;


/* Este componente es la tabla que muestra el listado  de cada pestania
seleccionada en la  bandeja de entrada*/

function TablaBandeja({
  datos,
  banderaVisualizar,
  keyTabPane,
  tituloTabla,
  implantarAspirante,
  history,
  tipoUsuario,
  emitirOperacion,
  rolCaptura,
  proceso,
  rolOPLE,
  datosUsuario,
  actualizarCargando
}) {
  //State que se usa
  const [state, setState] = useState({ searchText: "" });

  const[modalTemplate, setModalTemplate] = useState({
    msj: '', 
    mostrar: false,
    tipo: 'info',
    img: undefined
  })

  const [visible, hacerVisible] = useState({
    visible: false,
    confirmDialog: false,
    conCompulsa: 1
  });
  const [visibleRepetido, hacerVisibleRepetido] = useState({
    visibleRepetido: false,
    confirmDialog: false,
  });
  const [aspirante, autorizarAspirante] = useState({
    folioAcceso: "",
    claveElector: "",
    idConvocatoria: ""
  });
  const [exito, setExito] = useState(false);
  const [doc, agregaDoc] = useState({});
  const [modalCorreo, setShowModalCorreo] = useState({
        visible: false,
        confirmDialog: false,
  });
  const [datosModalCorreo, setDatosModalCorreo] = useState({
      correo: "",
      asunto: "",
      mensaje: "",
      caracteresRestantes: 0,
      nombre: "",
      descripcionProceso: "",
      idProcesoElectoral: undefined,
      idDetalleProceso: undefined,
      idParticipacion: undefined,
      idAspirante: undefined
  });
  const [modalConfirmaCorreo, setShowModalConfirmaCorreo] = useState({
        visible: false,
        confirmDialog: false,
        mensajeConfirmacion: ""
  });


  const[modalErrorMsj, setShowModalErrorMsj] = useState({
    msjError: "", 
    abrirModalError: false
  })

  const[fileLists, setFileLists] = useState([]);

  const roles_solo_consulta =
  [ "SCE.CONSULTA_EXT.OPL.JL","SCE.CONSULTA.OC", "SCE.CONSULTA.JL", "SCE.CONSULTA.JD"
];

  /*Metodos para el manejo de tablas */
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setState({ searchText: selectedKeys[0] });
  };

  var handleReset = clearFilters => {
    clearFilters();
    setState({ searchText: "" });
  };

  const functionFilterIcon = filtered => (
    <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
  );
  const functionFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => {
    return (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar `}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Limpiar
        </Button>
      </div>
    );
  };

  const functionOnFilterDropdownVisibleChange = visible => {
  };

  const functionRender = text => {
    return (
      text + ""
    );
  };

  const functionRenderValidado = (text, record) =>  {
    let icono = record.estatusRegistro === 5 ? true: false;
    let asterisco = record.claveElector.length < 18 ? true: false;
    if(icono || asterisco){
      return (
        <span>
          {asterisco ? <b style={{color:'#C192F3'}}>*&nbsp;</b> : null}
          {icono ?
          <Popover placement="bottomRight"
              disabled={false}
              content={"El aspirante decidió declinar su solicitud."}>
                <marginRight>
            <img src={iconoDeclina} /> 
          </marginRight>
          </Popover>: null}{" "+text+""} 
        </span>
      );
    }else{
      return (
        text + ""
      );
    }
    
  };

  const asignarSedePantalla = async () => {
    //debugger;
    hacerVisible({ visible: false, confirmDialog: true });
    cargarAspirante(aspirante.idProceso, aspirante.idDetalle, aspirante.claveElector, aspirante.folioAcceso).then(datosAspirante => {
      implantarAspirante(datosAspirante);
      emitirOperacion({
        accion: "asignaSede"
      });
      history.push("/validacion_documentos");
    });
  };


  const consultar = async () => {
    const ipCliente = await obtenerIpCliente()

    var postData = {
      folioAcceso: aspirante.folioAcceso,
      claveElector: aspirante.claveElector,
      flujoCompulsa: aspirante.conCompulsa,
      idProceso: aspirante.idProceso,
      idDetalle: aspirante.idDetalle,
      idParticipacion: aspirante.idParticipacion,
      ipUsuario : ipCliente
    };
    const jwt = localStorage.getItem("jwt-token");
    //si tiene compulsa tiene que actualizar BD  mostrar pantallla de exito
    if (aspirante.conCompulsa === 1) {
      const resultado = await axios.post(
        process.env.REACT_APP_API_URL +
        "/ws_reclutaseycae_central/ws/autoriza_aspirante",
        postData,
        { headers: { Authorization: jwt } }
      );
    }

    hacerVisible({ visible: false, confirmDialog: true });

    cargarAspirante(aspirante.idProceso, aspirante.idDetalle, aspirante.claveElector, aspirante.folioAcceso).then(datosAspirante => {
      implantarAspirante(datosAspirante);

      // Se autoriza al aspirante compulsado positivamente que ya estaba en estatus finalizado
      if(aspirante.estatusRegistro === 3)
        history.push(`/exito_actualiza/`);
      else if (aspirante.conCompulsa === 1) {
        // Si el aspirante no tiene observaciones en sus archivos, la acción será captura
        if(aspirante.tieneDocumentacion === 'S' && !aspirante.observacionesArchivos)
          emitirOperacion({accion: "captura"});
        else
          emitirOperacion({accion: "consulta"});

        history.push(`/exito_autoriza/tipoAspirante/${aspirante.observacionesArchivos}&${aspirante.tieneDocumentacion}&${aspirante.conCompulsa}&${aspirante.idProceso}&${aspirante.idDetalle}&${aspirante.claveElector}&${aspirante.folioAcceso}`);
      }
      // si no se tiene compulsa por descargar entonces es aspirante que ya ha subido su documentacion
      else if(aspirante.conCompulsa === 0 || aspirante.conCompulsa === null) {
        emitirOperacion({accion: "captura"});
        //verifica si la clave de elector esta repetida en la misma convocatoria
        axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/esClaveRepetida',  {
          idProcesoElectoral: aspirante.idProceso,
          idDetalleProceso: aspirante.idDetalle,
          idParticipacion: aspirante.idParticipacion,
          idConvocatoria: aspirante.idConvocatoria,
          folio: aspirante.folio,
          claveElectorFuar: aspirante.claveElector
        },{
          responseType: 'application/json',
          headers : {Authorization: jwt}
        }).then(res => {
          console.log(res.data);
          if(res.data.esClaveRepetida === true){
            keyTabPane === "3" ?
            history.push("/validacion_documentos") :
            hacerVisibleRepetido({visibleRepetido: true, confirmDialog: true});
          }else{
            history.push("/validacion_documentos");
          }
        });
      }
    });
  };
  
  const descargarCompulsa = async (record) => {
    let descargarArchivo;

    try{
    const idCorte = proceso ? proceso.corte : 0;
    await cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(async datosAspirante => {
      implantarAspirante(datosAspirante);

      const json = {
        idProcesoElectoral : record.idProceso,
        idDetalleProceso : record.idDetalle,
        idParticipacion : record.idParticipacion,
        idAspirante: datosAspirante.idAspirante,
        idConvocatoria :  record.idConvocatoria,
        folio : record.folio,
        claveElector: record.claveElector,
        idCorte : idCorte
      }

    descargarArchivo = await descargarAcuseCompulsa(json, `Compulsa_${datosAspirante.claveElectorFuar}.pdf`, 'descargarAcuse', TIPO_ARCHIVO_PDF);
    
    })
    }catch(err) {
      console.log("Error al descargar la compulsa", err)
      setModalTemplate({
        msj: general_error_descarga_archivo, 
        mostrar: true,
        tipo: 'error',
        img: errorImgModal
      });
    } finally {
      actualizarCargando({cargando:false})
      
      if(!descargarArchivo){
        setModalTemplate({
          msj: bandeja_descarga_pdf_compulsa_en_proceso, 
          mostrar: true,
          tipo: 'info',
          img: infoImgModal
        });
      }
    }
  };
  const mostrarModal = async (record) => {

    autorizarAspirante({
      folioAcceso: record.folioAcceso,
      claveElector: record.claveElector,
      conCompulsa: record.conCompulsa,
      idProceso: record.idProceso,
      idDetalle: record.idDetalle,
      idParticipacion: record.idParticipacion,
      idConvocatoria: record.idConvocatoria,
      folio: record.folio,
      estatusRegistro: record.estatusRegistro,
      motivoDeclinacion: record.motivoDeclinacion,
      tieneDocumentacion: record.tieneDocumentacion,
      observacionesArchivos: record.observacionesArchivos
    });
    hacerVisible({ visible: true, conCompulsa: record.conCompulsa });
  };
  const aceptar = async () => {
    keyTabPane === "5" ? asignarSedePantalla() : consultar();
  };
  const descargar = async () => {
    descargarCompulsa();
  };
  const cancelar = async () => {
    autorizarAspirante({});
    hacerVisible({ visible: false, conCompulsa: 1 });
  };
  const cerrarRepetido = async () => {
    autorizarAspirante({});
    hacerVisibleRepetido({visibleRepetido: false});
  };
  const showModalCorreo = async (record) => {
    setDatosModalCorreo({
        correo: record.correoElectronico,
        asunto: obtenerNombreBandeja(keyTabPane),
        mensaje: "",
        caracteresRestantes: 3000,
        nombre: record.nombre,
        descripcionProceso: proceso.descripcionDetalleLarga,
        idProcesoElectoral: record.idProceso,
        idDetalleProceso: record.idDetalle,
        idParticipacion: record.idParticipacion,
        idAspirante: record.idAspirante
    });
    setShowModalCorreo({ visible: true, confirmDialog: true});
    setFileLists([]);
  };
  const hideModalCorreo = async (record) => {
      setShowModalCorreo({visible: false, confirmDialog: false });
   };
  const handleOnChangeModalCorreo = (event) => {
    setDatosModalCorreo({
        correo: datosModalCorreo.correo,
        asunto: datosModalCorreo.asunto,
        mensaje: event.target.value,
        caracteresRestantes: 3000 - event.target.value.length,
        nombre: datosModalCorreo.nombre,
        descripcionProceso: datosModalCorreo.descripcionProceso,
        idProcesoElectoral: datosModalCorreo.idProcesoElectoral,
        idDetalleProceso: datosModalCorreo.idDetalleProceso,
        idParticipacion: datosModalCorreo.idParticipacion,
        idAspirante: datosModalCorreo.idAspirante
    });
    }
    const hideModalConfirmaCorreo = async (record) => {
        setShowModalConfirmaCorreo({ visible: false, confirmDialog: false });
        setShowModalCorreo({visible: false, confirmDialog: false });
  };
  const enviarCorreo = async () => {
    try {
      
      if (datosModalCorreo.mensaje === "") {
        setShowModalConfirmaCorreo({ visible: true, confirmDialog: true, mensajeConfirmacion: etiqueta_mensaje_vacio_aspirante });
        return;
      }

      const ipCliente = await obtenerIpCliente()
      let docAdjunto = fileLists[0];
      const formData = new FormData();

      var postData = {
          idProcesoElectoral: datosModalCorreo.idProcesoElectoral,
          idDetalleProceso: datosModalCorreo.idDetalleProceso,
          idParticipacion: datosModalCorreo.idParticipacion,
          idAspirante: datosModalCorreo.idAspirante,
          correo: datosModalCorreo.correo,
          asunto: datosModalCorreo.asunto,
          mensaje: datosModalCorreo.mensaje,
          nombre: datosModalCorreo.nombre,
          descripcionProceso: datosModalCorreo.descripcionProceso,
          usuario: datosUsuario.username,
          ipUsuario: ipCliente,
          uid: '',
          type: '',
          name: ''
      };

      if(docAdjunto !== undefined && fileLists.length > 0){
        postData.uid = docAdjunto.uid;
        postData.type = docAdjunto.type;
        postData.name = docAdjunto.name;
      }

      formData.append('files', docAdjunto);
      formData.append('dtoRequest',new Blob([JSON.stringify(postData)],{type:"application/json"}));

      const jwt = localStorage.getItem("jwt-token");

      actualizarCargando({cargando:true});

      const resultado = await axios.post(
          process.env.REACT_APP_API_URL +
          "/ws_reclutaseycae_central/ws/enviarNotificacionPersonalizada",
          formData,
          { headers: { 
            'Content-Type': 'multipart/form-data',
            Authorization: jwt 
          } }
          );

      if (resultado.data.status === 'Éxito' && (resultado.data.code === 200 || resultado.data.code === 201)) {
            setShowModalConfirmaCorreo({ visible: true, confirmDialog: true, mensajeConfirmacion: etiqueta_mensaje_enviado });
      } else {

        if(resultado.data.code === 400){
          let msjError = resultado.data.message;
          if(resultado.data.message === null){
            msjError = "Ocurrió un error en la carga de documentos. Por favor inténtalo más tarde.";
          }
          handleOnChangeModalErrorMsj(msjError, true);
        }else{
          setShowModalConfirmaCorreo({ visible: true, confirmDialog: true, mensajeConfirmacion: etiqueta_mensaje_no_enviado });
        }
      }

      actualizarCargando({cargando:false})
    } catch(err) {
      console.log(err);
      actualizarCargando({cargando:false})
    }
  }; 
  const etiquetaDescargaCompulsa = (text, record) => {
    var esClaveElectorFuar = REGEX_FORMATO_SOLO_DIGITOS.test(record.claveElector);
    
    return (
      record.conCompulsa === 1 || record.conCompulsa === 0 || record.conCompulsa === null ?
        <span>
          <a href="#" disabled={esClaveElectorFuar || rolOPLE}
            onClick={() => descargarCompulsa(record)}
            size="small"
            style={{ width: 90, textDecorationLine: 'underline' }}
          >
            Descargar
          </a>
        </span>
        :
        <span style={{textAlign:'center'}}>
          Descargar&nbsp;
          <Popover placement="bottomRight"
            disabled={false}
            content={etiqueta_bandeja_compulsa_en_ejecucion}>
              <marginRight>
                <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
              </marginRight>
          </Popover>
        </span>
    );
  };

  const etiquetaAutorizar = (text, record) => {
    return (
      record.conCompulsa === 1 ?
          <span>
            <Link to="#" onClick={() => mostrarModal(record)} size="small" style={{ width: 180, textDecorationLine: 'underline' }} disabled={!rolCaptura || rolOPLE} >
              Autorizar
            </Link>
          </span> :
          <span>
            {
              keyTabPane === "4" ?
                  <Link to="#" disabled={(record.tieneDocumentacion === 'N' && record.estatusRegistro !== 5 ? true : false) || rolOPLE || record.conCompulsa === -1} onClick={() => mostrarModal(record)} size="small" style={{ width: 180, textDecorationLine: 'underline' }} >
                    Revisar 
                  </Link>
                :
                  <Link disabled={rolOPLE || record.conCompulsa === -1} to="#" onClick={() => mostrarModal(record)} size="small" style={{ width: 180, textDecorationLine: 'underline' }} >
                    Revisar 
                  </Link>
            }
            {
              // En caso de que haya ocurrido un error en la ejecución de la compulsa, se mostrará un tooltip ya que se deshabilitará el botón por validar
              record.conCompulsa === -1 ?
                popOverCompulsaEnEjecucion()
              :
                // La condición aplica solo para la bandeja de declinados
                record.tieneDocumentacion === 'N' && keyTabPane === "4" && record.estatusRegistro !== 5 ?
                <>
                  &nbsp;
                  <Popover placement="bottomRight"
                    disabled={false}
                    content={etiqueta_bandeja_informacion_sin_documentos}>
                      <marginRight>
                        <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
                      </marginRight>
                  </Popover>
                </>
                :
                ""
            }
          </span>
    );
  };

  const accionAutorizar = () => {
    return (<>
      <span>Acción&nbsp;</span>
      <Popover placement="bottomRight"
               disabled={false}
               content={<img src={ayudaBAcudirJDE} width='500px' />}>
        <marginRight>
          <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
        </marginRight>
      </Popover>
      </>
    );
  };

  const etiquetaObservaciones = (text, record) => {
    record.observacionesArchivos === true ? (
      <span>
        <Icon type="reload" theme="outlined" style={{ fontSize: "16px", color: "#08c" }} />
        Con observaciones
      </span>
    ) : (
        <span></span>
      );
  }

  const etiquetasAcciones = (text, record) => {
    return (
      <span>
        <Link disabled={rolOPLE || record.conCompulsa===-1} to=""
            className="btn btn-success mr-2"
            onClick={() =>
              cargarAspirante(record.idProceso, record.idDetalle, record.claveElector, record.folioAcceso).then(datosAspirante => {
                emitirOperacion({
                  accion: keyTabPane === "1" ? "captura" : "consulta"
                });
                implantarAspirante(datosAspirante);

                history.push("/validacion_documentos");
              })
            }
            style={{textDecorationLine: 'underline'}}
          >
          {keyTabPane === "1" ? "Validar": "Ver detalle"}
        </Link>
        {
          // En caso de que haya ocurrido un error en la ejecución de la compulsa, se mostrará un tooltip ya que se deshabilitará el botón por validar
          record.conCompulsa === -1 ?
            popOverCompulsaEnEjecucion()
          :
            ''
        }
      </span>
    );
  };

  const popOverCompulsaEnEjecucion = () => {
    return (
      <>
        &nbsp;
        <Popover placement="bottomRight"
            disabled={false}
            content={etiqueta_bandeja_compulsa_en_ejecucion}>
          <marginRight>
            <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
          </marginRight>
        </Popover>
      </>    
    )
  }

  const accionAsignarSede = () => {
    return (<>
      <span>Asignar sede&nbsp;</span>
      <Popover placement="bottomRight"
               disabled={false}
               content={<img src={ayudaAsignar} width='500px' />}>
        <marginRight>
          <Icon type="info-circle" theme="filled" style={{ color: '#bfbfbf' }} />
        </marginRight>
      </Popover>
      </>
    );
  };

  const etiquetaAsignarSede = (text, record) => {
    return (
      record.idSedeProgramada !== null ?
          <span>
            <Link disabled={rolOPLE} to="#" size="small" style={{ width: 180, textDecorationLine: 'underline', color: '#bfbfbf', cursor: 'no-drop' }} >
              Asignada
            </Link>
          </span> :
          <span>
            {
              record.idPlatica !== null || record.bPlatica !== null ?
                <Link disabled={rolOPLE || record.conCompulsa === -1} to="#" onClick={() => mostrarModal(record)} size="small" style={{ width: 180, textDecorationLine: 'underline' }} >
                  Asignar
                </Link>
              :
                <Link disabled={rolOPLE || record.conCompulsa === -1} to="#" size="small" style={{ width: 180, textDecorationLine: 'underline', color: '#bfbfbf', cursor: 'no-drop' }} >
                  Asignar
                </Link>
            }
            {
              // En caso de que haya ocurrido un error en la ejecución de la compulsa, se mostrará un tooltip ya que se deshabilitará el botón por validar
              record.conCompulsa === -1 ?
                popOverCompulsaEnEjecucion()
              :
                ''
            }
          </span>
    );
  };

  const linkEnviarCorreo = (text, record) => {
    return (
        <span>
            {record.correoElectronico !== null
                ? <Link disabled={rolOPLE} to="#" onClick={() => showModalCorreo(record)} size="small" style={{ width: 180, textDecorationLine: 'underline' }} >
                    Enviar correo
                  </Link>
                : ''
            }
        </span>
        );
  };

  const OC = 1;
  const JL = 2;

const funcValida = (text, record) => {
  if(text.idDomAspirante > 0){
    //if(text.idDomAspirante == 1)
    //{
      return('class-otro')
    //}else{return('')}
  }else{return('')}
  
}

const funcRevisaDeclina = (record) => {
  
  if(aspirante.estatusRegistro !== 5){
    return(
    <span>
      <div className="mensaje_confirmacion">Revisar la documentación</div>
      <br></br>
      <div id="modal_botones">
                <Button className="botonesModalBandeja" onClick={cancelar}>
                  Cancelar
                </Button>
                <Button className="botonesModalBandeja" onClick={aceptar}>
                  Aceptar
                </Button>
        </div>
    </span>);
  }else{
    return(
      <span>
        <div className="titulosAvisoPrivacidad" style={{ fontSize: '24px', textAlign: 'center', fontWeight: 'medium'}}>
                      Detalle de la declinación
                    </div>
        <div>
        <br/>
        <Text style={{color: '#1890ff', fontStyle: 'bold'}}>
                          <Icon type="info-circle" theme="filled"
                              style={{fontSize: '1.0em'}} />
                                  {' '}  La o el aspirante decidió declinar su solicitud para participar como SE o CAE.
                        </Text>
        </div><br/>
        <div><Text style={{fontSize:'15px'}}>Motivo por el que declinó su solicitud: </Text><br/><br/></div>
        <div>
        <Text style={{fontStyle: 'Italic'}}>{aspirante.motivoDeclinacion}</Text>
        </div>
        
      
      {aspirante.tieneDocumentacion === "N" && aspirante.estatusRegistro === 5 ? 
      <span><br/>
        <div style={{ textAlign: 'center'}}><Text style={{color:'rgb(219, 36, 145)', textAlign:'center', fontStyle:'Bold'}}>La o el aspirante no cuenta con documentación cargada.</Text></div>
        <br></br>
        <div style={{ textAlign: 'center'}}>
        <Button className="botonesModalBandeja" onClick={cancelar}>
                  Cancelar
                </Button>
                </div>
      </span>
      :
      <span>
      <br/>
        <div className="mensaje_confirmacion">Revisar la documentación</div>
        <div id="modal_botones">
                <Button className="botonesModalBandeja" onClick={cancelar}>
                  Cancelar
                </Button>
                <Button className="botonesModalBandeja" onClick={aceptar}>
                  Aceptar
                </Button>
        </div>
        </span>
    }
        </span>
      
    );
  }
}

const funcFileValidation = (archive) => {

  let msjError = '';
  const permitido = archive.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || 
                    archive.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                    archive.type === 'application/pdf';

  if (!permitido) {
    msjError = 'El archivo ' + archive.name + ' es de formato no permitido. ' + etiquetas.gral_archivos_permitidos_envia_correo;
    handleOnChangeModalErrorMsj(msjError, true);
    return false;
  }
  
  //Tamanio del archivo no puede superar los 5 MB
  let tamanioPermitido = archive.size / 1024 / 1024 < 5; //5 MB
  let archivoVacio = archive.size === 0;
  if (!tamanioPermitido) {
      msjError = 'El archivo ' + archive.name + etiquetas.gral_peso_archivo_envia_correo;
      handleOnChangeModalErrorMsj(msjError, true);
      return false;
  }

  if(archivoVacio){
    msjError = 'El archivo ' + archive.name + ' está vacío';
    handleOnChangeModalErrorMsj(msjError, true);
    return false;
  }

  let restador = 5;
  if(archive.type === 'application/pdf'){
    restador = 4;
  }
  
  let nombreLargo = archive.name.substring(0, archive.name.length - restador).length > 100;

  if(nombreLargo){
    msjError = 'El nombre del archivo ' + archive.name + ' es más largo de lo permitido';
    handleOnChangeModalErrorMsj(msjError, true);
    return false;
  }

  let archNombrePermitido = validaNombreArchivo(archive.name);
  if(!archNombrePermitido){
    msjError = 'El nombre de archivo '+ archive.name + ' es inválido. '+ etiquetas.gral_error_nombre_archivo;
    handleOnChangeModalErrorMsj(msjError, true);
    return false;
  }

  return permitido && tamanioPermitido && archNombrePermitido && !archivoVacio && !nombreLargo
}

const cerrarErrorModal = () => {
  setShowModalErrorMsj({
    msjError:'',
    abrirModalError:false
  });
}

const validaNombreArchivo = (e) =>{
  var patron = /^[0-9a-zA-Z_-\s]+.[pdf/PDF/docx/DOCX/xlsx/XLSX]+$/;
  if(e.match(patron)){
      return true;
  }else{
      return false;
  }
}

const funcChangeList = (func, datosArchivo) => {
  console.log("Entre revisar los cambios en la lista de archivos");
  //Ejecuto el beforeUpload de FileUpload, me permite verificar si el archivo ya fue previamente agregado
  //Returna un array
  const nuevosArchivos = func(fileLists);
  //Validamos 
  if(nuevosArchivos.length>0){
    let repetido = fileLists.length > 0 && fileLists.some(valor=>{return valor.name === nuevosArchivos[0].name});
    if(repetido){
      datosArchivo.archivo = nuevosArchivos && nuevosArchivos[0] !== undefined ? nuevosArchivos[0] : undefined;
      let msjError = 'El archivo ' + nuevosArchivos[0].name + ' se encuentra previamente especificado';
      handleOnChangeModalErrorMsj(msjError, true);
      return fileLists;
    }
    setFileLists([nuevosArchivos[0]]);

  }else{
    setFileLists([]);
  }

}

const handleOnChangeModalErrorMsj = (msjError, abrirModal) => {
  setShowModalErrorMsj({
    msjError: msjError,
    abrirModalError: abrirModal
  });
}

  /*   Pintar la tabla     */
  return (
    <Fragment key={keyTabPane}>

      {banderaVisualizar === true ? (
        <Table title={() => tituloTabla} dataSource={datos} scroll={{ x: 'max-content' }} rowClassName={funcValida}>
          {tipoUsuario === OC ? (
            <Column
              title="Estado"
              dataIndex="estado"
              key={`estado{keyTabPane}`}
/*               filterDropdown={functionFilterDropdown}
              filterIcon={functionFilterIcon} */
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["estado"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />
          ) : (
              <span></span>
            )}

          {tipoUsuario === OC || tipoUsuario === JL ? (
            <Column
              title="Distrito"
              dataIndex="distrito"
              key={`distrito{keyTabPane}`}
              // filterDropdown={functionFilterDropdown}
              // filterIcon={functionFilterIcon}
              OnFilterDropdownVisibleChange={
                functionOnFilterDropdownVisibleChange
              }
              render={functionRender}
              onFilter={(value, record) => {
                return record["distrito"]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase());
              }}
            />
          ) : (
              <span></span>
            )}
          <Column
            title="Folio"
            dataIndex="folio"
            key={`folio{keyTabPane}`}
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            OnFilterDropdownVisibleChange={
              functionOnFilterDropdownVisibleChange
            }
            render={functionRender}
            onFilter={(value, record) => {
              return record["folio"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          <Column
            title="Nombre"
            dataIndex="nombre"
            key={`nombre{keyTabPane}`}
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            OnFilterDropdownVisibleChange={
              functionOnFilterDropdownVisibleChange
            }
            render={functionRenderValidado}
            onFilter={(value, record) => {
              return record["nombre"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          <Column
            title="Clave de elector o SIAP"
            dataIndex="claveElector"
            key={`claveElector{keyTabPane}`}
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            OnFilterDropdownVisibleChange={
              functionOnFilterDropdownVisibleChange
            }
            render={functionRender}
            onFilter={(value, record) => {
              return record["claveElector"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          <Column
            title="Registro"
            dataIndex="fechaSolicitud"
            key="fechaSolicitud"
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            render={functionRender}
            onFilter={(value, record) => {
              return record["fechaSolicitud"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          <Column
            title="Sección"
            dataIndex="seccion"
            key="seccion"
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            render={functionRender}
            onFilter={(value, record) => {
              return record["seccion"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          <Column
            title="Convocatoria"
            dataIndex="numeroConvocatoria"
            key="numeroConvocatoria"
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            render={functionRender}
            onFilter={(value, record) => {
              return record["numeroConvocatoria"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          <Column
            title="Sede"
            dataIndex="numeroSede"
            key="numeroSede"
            filterDropdown={functionFilterDropdown}
            filterIcon={functionFilterIcon}
            render={functionRender}
            onFilter={(value, record) => {
              return record["numeroSede"]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }}
          />
          {keyTabPane === "1" || keyTabPane === "2" ? (
            <Column title="" key="action" render={etiquetasAcciones} />
          ) : (
              null
            )}
          {keyTabPane === "1" ? (
            <Column title="" key="obs" render={etiquetaObservaciones} />
          ) : (
              null
            )}
          {keyTabPane === "3" || (keyTabPane === "5" && tipoUsuario !== OC) ? (
            <Column
              title="Compulsa"
              key="compulsa"
              render={etiquetaDescargaCompulsa}
            />
          ) : (
              null
            )}
          {keyTabPane === "3" ? (
            <Column title={accionAutorizar} key="autorizar" render={etiquetaAutorizar} />
          ) : (
              null
            )}
          {keyTabPane === "4" ? (
            <Column title="Acción" key="revertir" render={etiquetaAutorizar} />
          ) : (
              null
            )}
          {keyTabPane === "5" && rolCaptura ? (
            <Column title={accionAsignarSede} key="asignarSede" render={etiquetaAsignarSede} />
          ) : (
              null
            )}

           <Column title="" key="enviarCorreo" render={linkEnviarCorreo} />

        </Table>
      ) : (
          <span></span>
        )}

      <div>
        
        <Modal title={null}
               visible={visible.visible}
               confirmLoading={visible.confirmDialog}
               onOk={aceptar}
               onCancel={cancelar}
               okText="Aceptar"
               cancelText="Cancelar"
               closable={false}
               footer={null}
               width={'40%'}
        >
          
          {keyTabPane === "5" ? 
            <span>
              <div className="mensaje_confirmacion">Va a asignar sede ¿Desea continuar?</div>
              <br></br>
              <div id="modal_botones">
                <Button className="botonesModalBandeja" onClick={cancelar}>
                  Cancelar
                </Button>
                <Button className="botonesModalBandeja" onClick={aceptar}>
                  Aceptar
                </Button>
              </div>
            </span>
          
          : visible.conCompulsa === 1 ?
          <span>
            <div className="mensaje_confirmacion">¿Estás seguro de autorizar el registro?</div> 
            <br></br>
            <div id="modal_botones">
                <Button className="botonesModalBandeja" onClick={cancelar}>
                  Cancelar
                </Button>
                <Button className="botonesModalBandeja" onClick={aceptar}>
                  Aceptar
                </Button>
              </div>
          </span>: funcRevisaDeclina()
                                
          }
        </Modal>
      </div>
      <div>
        <Modal title={null}
               visible={visibleRepetido.visibleRepetido}
               confirmLoading={visibleRepetido.confirmDialog}
               onCancel={cerrarRepetido}
               centered
               closable={true}
               footer={null}
        >
          <div className="mensaje_confirmacion" style={{margin:'5px 25px'}}>
            <span style={{ fontSize: '18px', textAlign: "justify"}}>
              El registro del aspirante fue declinado, por lo tanto, volvió a realizarlo y se encuentra actualmente con dicho registro activo.
              Es por ello que a esta declinación, no podrás realizarle ninguna modificación.
            </span>
            <br/>
          </div>
        </Modal>
        </div>
        <ModalCorreo
              actualizarCargando={actualizarCargando}
              visible={modalCorreo.visible}
              confirmLoading={modalCorreo.confirmDialog}
              enviarCorreo={enviarCorreo}
              hideModalCorreo={hideModalCorreo}
              correo={datosModalCorreo.correo}
              asunto={datosModalCorreo.asunto}
              mensaje={datosModalCorreo.mensaje}
              caracteresRestantes={datosModalCorreo.caracteresRestantes}
              handleOnChangeModalCorreo={handleOnChangeModalCorreo}
              visibleConfirma={modalConfirmaCorreo.visible}
              confirmDialogConfirma={modalConfirmaCorreo.confirmDialog}
              hideModalConfirmaCorreo={hideModalConfirmaCorreo}
              mensajeConfirmacion={modalConfirmaCorreo.mensajeConfirmacion}
              validacion={funcFileValidation}
              fileLists={fileLists}
              cambiosList={funcChangeList}
          />
          <Modal className="modalError"
                 title={<img  src={errorImgModal} id="img-error-modal"/>}
                 centered
                 onCancel={cerrarErrorModal}
                 visible={modalErrorMsj.abrirModalError}
                 footer={false}
                 width={400}>
                    {modalErrorMsj.msjError}
          </Modal>
          <Modal className="modalInformativo"
                 title={<img  src={modalTemplate.img} id="img-error-modal"/>}
                 centered
                 onCancel={ ()=> setModalTemplate({mostrar:false})}
                 visible={modalTemplate.mostrar}
                 footer={false}
                 width={400}>
                    {modalTemplate.msj}
          </Modal>
    </Fragment>
  );
}

const mapStateToProps = createStructuredSelector({
  proceso: selectProceso,
  datosUsuario: selectCurrentUser,
});

export default withRouter(
  connect(
    mapStateToProps,
    { implantarAspirante, emitirOperacion }
  )(TablaBandeja)
);

var css = ' .class-otro{  color: var(--rosa-ine) !important;}',
    head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

head.appendChild(style);

style.type = 'text/css';
if (style.styleSheet){
  // This is required for IE8 and below.
  style.styleSheet.cssText = css;
} else {
  style.appendChild(document.createTextNode(css));
}
